import { render, staticRenderFns } from "./ChangeOfSecretary.vue?vue&type=template&id=5d737f04&scoped=true&"
import script from "./ChangeOfSecretary.vue?vue&type=script&lang=js&"
export * from "./ChangeOfSecretary.vue?vue&type=script&lang=js&"
import style0 from "./ChangeOfSecretary.vue?vue&type=style&index=0&id=5d737f04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d737f04",
  null
  
)

export default component.exports